import { render, staticRenderFns } from "./VisiMisi.vue?vue&type=template&id=10b77510&scoped=true"
import script from "./VisiMisi.vue?vue&type=script&lang=js"
export * from "./VisiMisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b77510",
  null
  
)

export default component.exports